import { render, staticRenderFns } from "./MedicationTypes.vue?vue&type=template&id=fdc45c2c"
import script from "./MedicationTypes.vue?vue&type=script&lang=js"
export * from "./MedicationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports